import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refreshUser(); }, [refreshUser]);

  const wrap = async (fn) => {
    try { return { ok: true, data: await fn() }; }
    catch (e) { return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message }; }
  };

  const startRegister = (payload) => wrap(async () => (await api.post("/auth/register/start", payload)).data);
  const resendCode = (email) => wrap(async () => (await api.post("/auth/register/resend", { email })).data);
  const verifyRegister = (email, code) =>
    wrap(async () => { const { data } = await api.post("/auth/register/verify", { email, code }); setUser(data); return data; });
  const login = (email, password) =>
    wrap(async () => { const { data } = await api.post("/auth/login", { email, password }); setUser(data); return data; });
  const logout = async () => { try { await api.post("/auth/logout"); } catch {} setUser(false); };

  return (
    <AuthContext.Provider value={{ user, setUser, refreshUser, startRegister, resendCode, verifyRegister, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
